import SEO from "../components/SEO";
import "../styles/contact.css";

export default function Contact() {
  const phoneNumber = "919983765215";

  const whatsappMessage = encodeURIComponent(
    "Hi VK Bike On Rent, I want to enquire about bike, scooty or taxi rental services in Udaipur."
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=HMJM%2B296%2C%20Near%20Sai%20Baba%20Temple%2C%20Jagdish%20Chowk%2C%20Udaipur%2C%20Rajasthan%20313004";

  const mapEmbedUrl =
    "https://www.google.com/maps?q=HMJM%2B296%20Udaipur&output=embed";

  const breadcrumbs = [
    {
      name: "Home",
      url: "https://vkbikeonrent.in/",
    },
    {
      name: "Contact",
      url: "https://vkbikeonrent.in/contact",
    },
  ];

  const faqItems = [
    {
      question: "Where is VK Bike On Rent located in Udaipur?",
      answer:
        "VK Bike On Rent is located near Sai Baba Temple on Jagdish Temple Road, Jagdish Chowk, Udaipur, Rajasthan 313004.",
    },
    {
      question: "How can I book a bike or scooty in Udaipur?",
      answer:
        "You can contact VK Bike On Rent by phone or WhatsApp to check vehicle availability, current rental pricing and booking requirements.",
    },
    {
      question: "Can I contact VK Bike On Rent for taxi services?",
      answer:
        "Yes. VK Bike On Rent also provides taxi and cab service options in Udaipur. Contact the business to discuss availability and trip requirements.",
    },
    {
      question: "What are the opening hours?",
      answer:
        "VK Bike On Rent is listed as open 24 hours. Contact the business to confirm availability and booking assistance for your required time.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <>
      {/* =====================================================
          PAGE SEO
      ====================================================== */}

      <SEO
        title="Contact VK Bike On Rent | Bike & Scooty Rental in Udaipur"
        description="Contact VK Bike On Rent in Udaipur for bike, scooty and taxi rental availability, pricing and booking assistance. Located near Jagdish Chowk."
        canonical="https://vkbikeonrent.in/contact"
        breadcrumbs={breadcrumbs}
        schema={faqSchema}
      />

      {/* =====================================================
          CONTACT PAGE
      ====================================================== */}

      <main className="contact-page">

        <section
          className="contact-section"
          aria-labelledby="contact-title"
        >

          <div className="contact-container">

            {/* =================================================
                BUSINESS INFORMATION
            ================================================== */}

            <div className="contact-info">

              <header className="contact-header">

                <h1
                  id="contact-title"
                  className="contact-title"
                >
                  Contact VK Bike On Rent in Udaipur
                </h1>

                <p className="contact-description">
                  Looking to rent a bike, scooty or taxi in
                  Udaipur? Contact VK Bike On Rent to check
                  current availability, rental information,
                  pricing and booking requirements.
                </p>

              </header>

              {/* =================================================
                  GOOGLE RATING
              ================================================== */}

              <div
                className="google-badge"
                aria-label="VK Bike On Rent Google rating"
              >
                ⭐ 4.8 Google Rating
              </div>

              {/* =================================================
                  BUSINESS ADDRESS
              ================================================== */}

              <address className="contact-address">

                <p className="contact-item">

                  <span aria-hidden="true">
                    📍
                  </span>{" "}

                  <strong>
                    VK Bike On Rent
                  </strong>

                  <br />

                  HMJM+296, Near Sai Baba Temple,
                  <br />
                  Jagdish Temple Road, Jagdish Chowk,
                  <br />
                  Udaipur, Rajasthan 313004, India

                </p>

                {/* Phone */}

                <p className="contact-item">

                  <span aria-hidden="true">
                    📞
                  </span>{" "}

                  <strong>
                    Phone:
                  </strong>

                  <br />

                  <a
                    href={`tel:+${phoneNumber}`}
                    aria-label="Call VK Bike On Rent at plus 91 99837 65215"
                  >
                    +91 99837 65215
                  </a>

                </p>

                {/* WhatsApp */}

                <p className="contact-item">

                  <span aria-hidden="true">
                    💬
                  </span>{" "}

                  <strong>
                    WhatsApp:
                  </strong>

                  <br />

                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Contact VK Bike On Rent on WhatsApp"
                  >
                    Chat on WhatsApp
                  </a>

                </p>

                {/* Hours */}

                <p className="contact-item">

                  <span aria-hidden="true">
                    🕒
                  </span>{" "}

                  <strong>
                    Hours:
                  </strong>

                  <br />

                  Open 24 Hours

                </p>

              </address>

              {/* =================================================
                  CONTACT ACTIONS
              ================================================== */}

              <div
                className="contact-buttons"
                aria-label="Contact VK Bike On Rent"
              >

                <a
                  href={`tel:+${phoneNumber}`}
                  className="contact-btn call-btn"
                  aria-label="Call VK Bike On Rent"
                >
                  📞 Call Now
                </a>

                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-btn whatsapp-btn"
                  aria-label="Chat with VK Bike On Rent on WhatsApp"
                >
                  💬 Chat on WhatsApp
                </a>

                <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-btn map-btn"
                  aria-label="View VK Bike On Rent location on Google Maps"
                >
                  📍 View on Google Maps
                </a>

              </div>

            </div>

            {/* =================================================
                GOOGLE MAP
            ================================================== */}

            <div
              className="contact-map"
              aria-label="VK Bike On Rent location map"
            >

              <iframe
                title="VK Bike On Rent location near Jagdish Chowk, Udaipur"
                src={mapEmbedUrl}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />

            </div>

          </div>

        </section>

        {/* =====================================================
            SERVICE AREA
        ====================================================== */}

        <section
          className="contact-service-area"
          aria-labelledby="service-area-title"
        >

          <div className="section">

            <h2 id="service-area-title">
              Bike, Scooty & Taxi Rental Services in Udaipur
            </h2>

            <p>
              VK Bike On Rent serves visitors looking for
              convenient transportation options in Udaipur.
              Contact us for bike and scooty rental,
              taxi services, airport travel requirements,
              local sightseeing and other available rental
              options.
            </p>

            <p>
              The business is located near Jagdish Chowk,
              making it convenient for visitors staying around
              the old city and nearby tourist areas to contact
              the rental service.
            </p>

          </div>

        </section>

        {/* =====================================================
            FAQ / AEO
        ====================================================== */}

        <section
          className="contact-faq"
          aria-labelledby="contact-faq-title"
        >

          <div className="section">

            <header>
              <h2 id="contact-faq-title">
                Contact & Booking FAQs
              </h2>
            </header>

            {faqItems.map((item) => (
              <article
                className="faq-item"
                key={item.question}
              >

                <h3>
                  {item.question}
                </h3>

                <p>
                  {item.answer}
                </p>

              </article>
            ))}

          </div>

        </section>

      </main>
    </>
  );
}